const PREFIX = 'user-contractor';

export const UserContractorQueryKeys = {
  root: [PREFIX],
  contractor: [PREFIX, 'contractor'],
};
